import axios from 'axios';
import { BaseUrlGeneral } from '../utils';

//Generic axios instance
const axiosInstance = axios.create({
  baseURL: BaseUrlGeneral,
  timeout: 5000,
  headers: {
    Authorization: localStorage.getItem('jwt_token')
      ? 'bearer ' + localStorage.getItem('jwt_token')
      : null,
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

//Response middleware for axios instance
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    //If there is any internal server error this will popup an alert
    // if (typeof error.response === 'undefined') {
    //   alert(
    //     'A server/network error occurred. ' +
    //     'Sorry about this - we will get it fixed shortly.'
    //   );
    //   return Promise.reject(error);
    // }
    //if token is invalid or expired it will redirect to signin page
    if (
      error.response &&
      error.response?.status &&
      (error.response.status === 403 || error.response.status === 401)
    ) {
      window.location.href = '/signin/';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
